const API_BASE = 'https://sadaqa25api.ssfkerala.org';

function buildUrl(path) {
  if (path.startsWith('http')) {
    return path;
  }
  return `${API_BASE}${path}`;
}

async function authFetch(path, token, options = {}) {
  const headers = new Headers(options.headers || {});
  headers.set('Authorization', `Bearer ${token}`);
  if (!headers.has('Content-Type') && !(options.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(buildUrl(path), {
    ...options,
    headers,
  });

  let payload;
  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    const message = payload?.error || 'Request failed';
    const error = new Error(message);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

export function getUnitSummary(token) {
  return authFetch('/analytics/unit_summary.php', token, {
    method: 'GET',
  });
}

export function getUnitContributions(token, { page = 1, perPage = 25 } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });

  return authFetch(`/analytics/contributions.php?${params.toString()}`, token, {
    method: 'GET',
  });
}

export function createContribution(token, payload) {
  return authFetch('/contributions/add.php', token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function getContributionHistory(token, { page = 1, perPage = 50 } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });

  return authFetch(`/contributions/history.php?${params.toString()}`, token, {
    method: 'GET',
  });
}

export function updateContribution(token, payload) {
  return authFetch('/contributions/update.php', token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function deleteContribution(token, id) {
  return authFetch('/contributions/delete.php', token, {
    method: 'POST',
    body: JSON.stringify({ id }),
  });
}

export function getSectorSummary(token) {
  return authFetch('/analytics/sector_summary.php', token, {
    method: 'GET',
  });
}

export function getHierarchyAnalytics(token, entityId) {
  const path = entityId ? `/analytics/hierarchy.php?entity_id=${encodeURIComponent(entityId)}` : '/analytics/hierarchy.php';
  return authFetch(path, token, {
    method: 'GET',
  });
}

export function getHierarchyMembers(token, entityId, { page = 1, perPage = 50 } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });
  const basePath = entityId ? `/analytics/hierarchy_members.php?entity_id=${encodeURIComponent(entityId)}` : '/analytics/hierarchy_members.php';
  const delimiter = basePath.includes('?') ? '&' : '?';
  return authFetch(`${basePath}${delimiter}${params.toString()}`, token, {
    method: 'GET',
  });
}

export { API_BASE };
